import { render, staticRenderFns } from "./nbn-order-correction-form.vue?vue&type=template&id=1fe98d2a&scoped=true"
import script from "./nbn-order-correction-form.vue?vue&type=script&lang=js"
export * from "./nbn-order-correction-form.vue?vue&type=script&lang=js"
import style0 from "./nbn-order-correction-form.vue?vue&type=style&index=0&id=1fe98d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe98d2a",
  null
  
)

export default component.exports